var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFileOutlineFolderFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,19a3,3,0,0,1-3-3V7A3,3,0,0,1,3,4V3A3,3,0,0,1,5.824.005L6,0h8a3,3,0,0,1,2.994,2.823L17,3V6a3,3,0,0,1,3,2.824L20,9v7a3,3,0,0,1-3,3ZM2,7v9a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H10a.994.994,0,0,1-.7-.287L7.852,6.287A.994.994,0,0,0,7.151,6H3A1,1,0,0,0,2,7ZM7.151,4a2.982,2.982,0,0,1,2.105.863L10.41,6H15V3a1,1,0,0,0-.884-.993L14,2H6a1,1,0,0,0-.994.884L5,3V4Z",
    fill: "#212121"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileOutlineFolderFull);
export default __webpack_public_path__ + "static/media/Icon-File-Outline-Folder-Full.d4488f8ceb3286f44814a9327ee3f92c.svg";
export { ForwardRef as ReactComponent };